<template>
<div class="divider">
    <label class="contentLabel" for="className">{{ $t('Add.General.ClassNames') }}</label>
    <input
    type="text"
    id="className"
    v-model="newClassName"
    @keydown.enter.prevent="addClassName"
    placeholder="Enter class name and press Enter"
    />
</div>
<div class="class-names">
    <span v-for="(name, index) in classNames" :key="index" class="class-pill">
    {{ name }}
    <span class="material-symbols-outlined class-remove" @click="removeClassName(index)">close</span>
    </span>
</div>
</template>

<script>
export default {
    props: ['sharedData'],
    data() {
    return {  newClassName: '' };
    },
    computed:{
      classNames: {
      get() {
        return this.sharedData?.data?.props?.classNames || [];
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.classNames = value;
      },
      }},
    methods:{
    addClassName() {
    const trimmedName = this.newClassName.trim();
    if (trimmedName && !this.classNames.includes(trimmedName)) {
      this.classNames = [...this.classNames, trimmedName];
    }
    this.newClassName = '';
    this.$store.dispatch('addClass', trimmedName);
  },
    removeClassName(index) {
    const classNameToRemove = this.classNames[index]
    this.$store.dispatch('removeClass', classNameToRemove);
    this.classNames = this.classNames.filter((_, i) => i !== index);
    },}
  }
</script>

<style>
@import '../../../styles/addComponents.css';
</style>